import classnames from 'classnames';

import styles from './PendingCra.module.css';
import { ReactComponent as Plane } from './Plane.svg';

export const PendingCra = () => (
  <div>
    <div className={styles.header}>
      We're finishing setting up your account to accept payments
    </div>
    <div className={styles.subtext}>
      This can take up to a day, but we’ll email you as soon as it’s ready.
    </div>

    <div className={classnames(styles.svg, styles.svgContainer)}>
      <Plane />
    </div>
  </div>
);
